import { PaymentAccountOverdraftStoreService } from '@hb/modules/financial-obligations/payment-account-overdraft/payment-account-overdraft-store.service';
import { QuestionKey } from '@hb/modules/global/global.constants';
import { ExtraInformationComponent } from '@hb/modules/global/tip/extra-information.component';
import { NextButtonComponent } from '@hb/modules';

import { Component, inject } from '@angular/core';

import { ApContentPipe } from '@ap/content';

@Component({
    selector: 'payment-account-overdraft-tip',
    imports: [ExtraInformationComponent, NextButtonComponent, ApContentPipe],
    templateUrl: './payment-account-overdraft-tip.component.html'
})
export class PaymentAccountOverdraftTipComponent {
    protected readonly store = inject(PaymentAccountOverdraftStoreService);
    protected readonly questionKey = QuestionKey.PAYMENT_ACCOUNT_OVERDRAFT_TIP;

    nextQuestion(): void {
        this.store.setOverdraftTipFinished();
    }
}
